// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { ConfigurationService } from '../../services/configuration.service';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { Permission } from 'src/app/models/permission.model';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    animations: [fadeInOut]
})
export class HomeComponent
{
    constructor(
      public configurations: ConfigurationService,
      private router: Router,
      private accountService: AccountService)
    {
      
    }

    ngOnInit() {
      if (this.canViewUsers) {
        this.router.navigate(['/companiereprezentari']);
      }
      else {
        this.router.navigate(['/contulmeu']);
      }
    }

    get canViewUsers() {
      return this.accountService.userHasPermission(Permission.viewUsersPermission);
    }
}
